import { render, staticRenderFns } from "./ReviewCardLogo.vue?vue&type=template&id=1328bf8f&scoped=true&"
import script from "./ReviewCardLogo.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewCardLogo.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewCardLogo.vue?vue&type=style&index=0&id=1328bf8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1328bf8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1328bf8f')) {
      api.createRecord('1328bf8f', component.options)
    } else {
      api.reload('1328bf8f', component.options)
    }
    module.hot.accept("./ReviewCardLogo.vue?vue&type=template&id=1328bf8f&scoped=true&", function () {
      api.rerender('1328bf8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewCardLogo.vue"
export default component.exports